import {inject, Injectable, Signal} from "@angular/core";
import {DeviceActivityType} from "@models";
import {SimDeviceService} from "@services";

@Injectable({
	providedIn: "root",
})
export class AppDataSyncService {
	readonly #deviceService = inject(SimDeviceService);

	public preventInfiniteLoading(isLoading: Signal<boolean>, activityType: DeviceActivityType) {
		setTimeout(async () => {
			// Validate
			if (!isLoading()) {
				return;
			}

			// Request
			this.#deviceService.readyToCommunicate(activityType).finally(() => {
				if (isLoading()) {
					this.preventInfiniteLoading(isLoading, activityType);
				}
			});
		}, 3000);
	}
}
